<div class="row info">   


	<div style="margin-bottom:10px" class=" col-12"><b>{{playlist.title}}</b></div>

	

    <div class="col-12">

	   <div class="contentWrapper">
  

        <div class="infoWrapper">
        
		<div style="margin-top:0" class="streamPageInfo descriptionInfo">{{playlist.description || 'Опис'}}</div>


		
		<div style="display:flex;     flex-wrap: wrap-reverse;">
		 

		<div class="editLink">

			<a (click)="openModal(idetInfo)" href="javascript:;">Редагувати</a>
		</div>

		</div>
       </div>
  
       
 
   <div class="coverImageWrapp">

 

        <div   class="coverImage" [style.background]=" playlist.coverImage ? 'url(' + playlist.coverImage +')' : ''" ></div>

	<div class="coverImageControls">
       		 <p *ngIf="!playlist.coverImage"><a (click)="loadCoverInput.click()" href="javascript:;">Завантажити обкладинку</a>
		    <input #loadCoverInput (change)="loadCover($event.target)" style="display:none" class="hidden" type="file">
		</p>
	  
		<div *ngIf="playlist.coverImage">
		    <p><a (click)="deleteCover()" href="javascript:;">Видалити обкладинку</a></p>
		</div>
	 </div>
	 
    </div>



  </div>



  </div>



 </div>

  
 <ng-template #idetInfo  let-data   let-ref="dialogRef">

<div style="min-width:320px;">
  <form [formGroup]="infoForm"  (ngSubmit)="submitInfoForm(ref)">
	    <nb-card>
    <nb-card-header>

	
	<div style="display:flex; width:100%">
    <span>Редагувати опис</span>   
     <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
	</div>
</nb-card-header>
    <nb-card-body>
	<div>
      
        <div class="form-group">
                     <label for="playlist-title">Заголовок</label>

          <div class="input-group">
            <input id="playlist-title" 
            formControlName="title"
            nbInput fullWidth name="title" value="{{playlist.title}}" />
            

          </div>
           
          <span *ngIf="infoForm.get('title').invalid && infoForm.get('title').touched" class="fs--2 text-danger">
            <span *ngIf="infoForm.get('title').errors.required">Заголовок обов'язкове поле</span>
        </span>
        </div>
  
        <div class="form-group">
            <label for="playlist-description">Опис</label>
            <div class="input-group">
              <textarea id="playlist-description" 
              formControlName="description"
               nbInput fullWidth name="description">{{playlist.description}}</textarea>
            </div>
         </div>

	</div>
</nb-card-body>
    <nb-card-footer>
     
       
	<div style="display:flex; width:100%">
          
          <button style="display:flex; margin-left:auto; cursor: pointer;"  nbButton status="primary" [disabled]="infoForm.invalid" type="submit">Зберегти</button>

        </div>
    </nb-card-footer>
  </nb-card>
  
    </form> 
</div>
  </ng-template>
  
    
